export const imageUploaderConstants = {
    IMAGEUPLOAD_SET_IMAGE: 'IMAGEUPLOAD_SET_IMAGE',
    SET_IMAGE_TO_REMOVE: 'SET_IMAGE_TO_REMOVE',
    IMAGEUPLOAD_REMOVE_IMAGE: 'IMAGEUPLOAD_REMOVE_IMAGE',
    REQUEST_IMAGE_UPLOAD: 'REQUEST_IMAGE_UPLOAD',
    SUCCESS_IMAGE_UPLOAD: 'SUCCESS_IMAGE_UPLOAD',
    FAILURE_IMAGE_UPLOAD: 'FAILURE_IMAGE_UPLOAD',
    IMAGEUPLOAD_CLEAR: 'IMAGEUPLOAD_CLEAR'
};
